import {
  IconInstagram,
  IconTelegram,
  IconWhatsApp,
  IconYouTube,
  IconPlay,
  IconStar,
  IconBubble,
  IconZap,
  IconShield,
  IconGlobe,
  IconFashion,
  IconFood,
  IconTravel,
  IconTech,
  IconSports,
  IconEducation,
  IconEntertainment,
  IconMommy,
  IconMusic,
  IconBeauty,
  IconFinance,
  IconPets,
  IconBale,
  IconRubika,
  IconSoroush,
  IconEitaa,
  IconLinkedIn,
  IconTwitter,
  IconMail,
  IconPhone,
  IconPin,
} from './Icon'

/**
 * Lookup table for icon components. Lets data files reference icons by
 * string key instead of importing React components — that separation
 * keeps `lib/data/*` purely declarative and trivially JSON-serializable.
 */
export const iconRegistry = {
  instagram: IconInstagram,
  telegram: IconTelegram,
  whatsapp: IconWhatsApp,
  youtube: IconYouTube,
  play: IconPlay,
  star: IconStar,
  bubble: IconBubble,
  zap: IconZap,
  shield: IconShield,
  globe: IconGlobe,
  fashion: IconFashion,
  food: IconFood,
  travel: IconTravel,
  tech: IconTech,
  sports: IconSports,
  education: IconEducation,
  entertainment: IconEntertainment,
  mommy: IconMommy,
  music: IconMusic,
  beauty: IconBeauty,
  finance: IconFinance,
  pets: IconPets,
  bale: IconBale,
  rubika: IconRubika,
  soroush: IconSoroush,
  eitaa: IconEitaa,
  linkedin: IconLinkedIn,
  twitter: IconTwitter,
  mail: IconMail,
  phone: IconPhone,
  pin: IconPin,
} as const

export type IconKey = keyof typeof iconRegistry

export function RegistryIcon({ name, className }: { name: IconKey; className?: string }) {
  const Icon = iconRegistry[name]
  return <Icon className={className} />
}
